<template>
    <span class="label white_line"><span class="ellipsis">{{ title }}</span><v-icon x-small @click.stop="action_UnselectEmployee">mdi-close</v-icon></span>
</template>


<script>
export default {
    props: {
        employee: Object,
        index: Number
    },
    computed: {
        title: function() { return this.employee.title }
    },
    methods: {
        action_UnselectEmployee() {
            this.$emit('unselectEmployee', this.employee, this.index)
        }
    }
}
</script>